import React from 'react'
import { getPageData, useData } from '../../app/helper/functions'
import ReliabilityAboutUs from '../molecules/AboutUsComponents/ReliabilityAboutUs/ReliabilityAboutUs'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { motion } from 'framer-motion'
import OurStorySection from '../molecules/AboutUsComponents/OurStorySection/OurStorySection'
import FounderSection from '../molecules/AboutUsComponents/FounderSection/FounderSection'
import CompanySection from '../molecules/AboutUsComponents/CompanySection/CompanySection'
import CredentialsSection from '../molecules/AboutUsComponents/CredentialsSection/CredentialsSection'
import TechStackSection from '../molecules/AboutUsComponents/TechStackSection/TechStackSection'
import heroSvg from "../../app/assets/images/aboutUsImages/aboutus.svg";

const AboutUsPage = () => {
    const { data } = useData();
    const aboutUsData = getPageData(data, 'aboutUsPage');
    const fadeInUp = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3
            }
        }
    };

    const textStaggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const slideInFromLeft = {
        hidden: { x: -100, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const slideInFromRight = {
        hidden: { x: 100, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    return (
        <div className='overflow-x-hidden'>
            <div className='bg-black'>
                <motion.div
                    className='mx-auto pb-16 md:pb-20 flex w-full max-w-[2400px] flex-col items-center justify-center gap-6 px-4 pt-28 pb-0 sm:px-6 md:px-[6%] md:pt-[18%] lg:pt-[16%] xl:pt-[18%]  xl:px-[8%] 2xl:px-[10%] 2xl:pt-[17%] text-center'
                    variants={staggerContainer}
                    initial="hidden"
                    animate="visible"
                >
                    {/* ── Heading ── */}
                    <motion.div
                        className='text-[clamp(1.2rem,4vw,4.5rem)] font-bold capitalize leading-[1.06] tracking-tight text-white md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-[55px]'
                        variants={fadeInUp}
                    >
                        AI Automation & Agentic Systems
                    </motion.div>

                    {/* ── Description ── */}
                    <motion.div
                        className='max-w-[72ch] 2xl:max-w-[92ch] text-[clamp(0.78rem,2vw,1.5rem)] font-medium leading-[1.55] text-white/80 md:text-xl lg:text-2xl 3xl:text-4xl'
                        variants={fadeInUp}
                    >
                        The Sattva Tech is a technology consulting and engineering firm specializing in AI automation, agentic systems, blockchain infrastructure, healthcare and fintech solutions. We partner with startups and enterprises across the US, UK, EU, and Asia to build technology that scales and complies.
                    </motion.div>

                    {/* ── Image flush to bottom ── */}
                    <motion.img
                        src={heroSvg}
                        alt=""
                        className='w-full md:w-[90%] max-w-[2400px] object-contain object-bottom mt-4'
                        variants={fadeInUp}
                    />
                </motion.div>
            </div>



            <div className='bg-newbgcolor'>
                <section className='max-w-[2400px] mx-auto px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32 3xl:px-48 pt-12 md:pt-16 pb-10 md:pb-14 3xl:pt-24 3xl:pb-20'>
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.12 }}
                        transition={{ duration: 0.8 }}
                    >
                        <OurStorySection storySection={aboutUsData?.storySection} />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.12 }}
                        transition={{ duration: 0.8, delay: 0.05 }}
                    >
                        <FounderSection founderSection={aboutUsData?.founderSection} />
                    </motion.div>
                </section>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.12 }}
                    transition={{ duration: 0.8 }}
                    className='w-full bg-[#1E1E1E]'
                >
                    <CompanySection companySection={aboutUsData?.companySection} />
                </motion.div>

                {/* <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.12 }}
                    transition={{ duration: 0.8 }}
                >
                    <OurTeamSection teamSection={teamSection} />
                </motion.div> */}

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.12 }}
                    transition={{ duration: 0.8 }}
                >
                    <CredentialsSection credentialsSection={aboutUsData?.credentialsSection} />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.12 }}
                    transition={{ duration: 0.8 }}
                >
                    <TechStackSection techStackSection={aboutUsData?.techStackSection} />
                </motion.div>
                {/* <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <AboutUsImage />
                </motion.div> */}

                {/* <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <ReliabilityAboutUs aboutUsData={aboutUsData} />
                </motion.div> */}

                {/* <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <TeamExecutive />
                </motion.div> */}

                {/* <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <CoreTeam />
                </motion.div> */}

                <DefaultFooter />
            </div>
        </div>
    )
}

export default AboutUsPage
